import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_union_representatives_are_in_the_osh_committee'

export const dataPointDefinition = {
  retracedId: 'how_many_union_representatives_are_in_the_osh_committee',
  name: 'How many union representatives are in the OSH committee?',
  description: 'Do not include non-union worker representatives in this figure.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-hsc-7',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14460,
  sectionId: '2.2.9.3',
  impactArea: 'Engagement with OSH',
  impactAreaId: 'ENGAGEMENT_WITH_OHS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
